import { Navigate } from 'react-router-dom';
import React from 'react';
import About from './components/About';
import Services from './components/Services';
import FAQ from './components/FAQ';
import Home from './components/Home';
import SplatterSessions from './components/SplatterSessions';
import PrivateEvents from './components/PrivateEvents';


const routes = [
    {
        path: '/',
        component: <Home />,
    },
    // {
    //     path: '/wild-room',
    //     component: <WildRoom />,
    // },
    {
         path: '/about',
        component: <About />,
    },
    // {
    //     path: '/splatter-space',
    //     component: <SplatterSpace />,
    // },
    {
        path: 'private-events',
        component: <PrivateEvents />,
    },
    {
        path: '/splatter-sessions',
        component: <SplatterSessions />,
    },
    {
        path: '/faqs',
        component: <FAQ />,
    }
]

export default routes;